import { useEffect } from "react";

import { subscribeViewportMetrics } from "@/lib/viewport";

/**
 * Keeps `--app-vvw`, `--app-vvh`, and `--app-vv-offset-top` in sync with the
 * visual viewport on mobile browser tabs (URL bar / toolbar chrome) and while
 * the keyboard is open. Installed PWA / native use CSS `100vh` when the
 * keyboard is closed.
 */
export function useAppViewport() {
  useEffect(() => subscribeViewportMetrics(() => {}), []);
}
